import { Col, Container, Row } from 'reactstrap'
import LoginForm from '../Common/LoginForm'

const LoginWithValidationContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col xl="5" className="p-0">
          <LoginForm />
        </Col>
        <Col xl="7" className='loginImageBg1'></Col>
      </Row>
    </Container>
  )
}

export default LoginWithValidationContainer